var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 7.6001C14.4 8.26284 13.8628 8.8001 13.2 8.8001C12.5373 8.8001 12 8.26284 12 7.6001V2.8001C12 2.13736 12.5373 1.6001 13.2 1.6001C13.8628 1.6001 14.4 2.13736 14.4 2.8001V7.6001Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 7.73343V3.38895C11.2 2.78292 10.8576 2.2289 10.3156 1.95787L10.2757 1.93793C9.83136 1.71576 9.3414 1.6001 8.84461 1.6001L4.51172 1.6001C3.74903 1.6001 3.09236 2.13843 2.94279 2.88631L1.98279 7.68631C1.78477 8.67638 2.54204 9.6001 3.55171 9.6001H6.40003V12.8001C6.40003 13.6838 7.11637 14.4001 8.00003 14.4001C8.44186 14.4001 8.80003 14.0419 8.80003 13.6001V13.0668C8.80003 12.3744 9.0246 11.7007 9.44003 11.1468L10.56 9.65343C10.9755 9.09952 11.2 8.42582 11.2 7.73343Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.d956836adec8796b6ef93a611e0ed6f8.svg";
export { ForwardRef as ReactComponent };